module.exports = __webpack_public_path__ + "img/Card_SwordLight_Blue-min.00459d40.png";